import React, { useRef, useState }  from 'react';
import { useDispatch }              from 'react-redux';
import { Button, Form, Modal }      from 'react-bootstrap';
import Select                       from 'react-select';
import { Formik }                   from 'formik';
import * as yup                     from 'yup';

import clienteAxios                 from '../../../config/axios';

import { cloneAudienceAction }      from '../../../actions/audiencesActions';
import { ErrorMessage }             from '../../extras/toastMessages';
import { ICON_CANCEL, ICON_SAVE }   from '../../extras/icons';
import { MSG_ERROR_SERVER }         from '../../../constants/messages';


const CloneModal = props => {

    //Tomo los props
    const { audience, handleClose, show } = props;

    //Genero los ref
    const refTiposDeAudiencia = useRef();
    
    //Inicializo el dispatch
    const dispatch = useDispatch();

    //Inicializo datos
    const initialData = {
        observaciones: '',
        tiposDeAudiencia: audience?.audienciaTipoList 
            ? 
                audience.audienciaTipoList.map(at=>
                ({  id: at.id,
                    value: at.id,
                    label: at.descripcion
                }) )
            : 
                []
    }
    
    //Inicializo el state local
    const [AudienciaTipos, setAudienciaTipos] = useState([]);
    const [observaciones, setObservaciones] = useState('');
    const [selectedAudienciaTipos, setSelectedAudienciaTipos] = useState(initialData.tiposDeAudiencia);

    //Manejo cuando se muestra
    const handleOnShow = e => {
        setSelectedAudienciaTipos(initialData.tiposDeAudiencia)
        //Cargo los motivos
        loadParameters();
        //Pongo el foco en el primer campo
        refTiposDeAudiencia.current.focus();
    }

    //Manejo cambio de las observaciones
    const handleChangeObservaciones = (e) => {
        setObservaciones(e.target.value) ;
    }

    //Manejo cambio del select
    const handleChangeTipos = (options, setFieldValue) => {
        //Seteo los datos
        setSelectedAudienciaTipos(options ? options.map(option => (
            {   id: option.value,
                value: option.value,
                label: option.label
            }
        )) : [])
        //Seteo el valor
        setFieldValue('tiposDeAudiencia', options ? options : [], true);
    }

    //Manejo el guardado
    const handleSave = () => {
        //Armo los datos
        const data = {
            observacionSolicitante: observaciones,
            tiposDeAudiencia: selectedAudienciaTipos
        }
        //Llamo al dispatch
        dispatch( cloneAudienceAction(audience, data, handleClose) );
    }

    //Función que cargar los parámetros
    const loadParameters = async () => {
        try
        {   //Tipos de Audiencia
            const responseAudienciaTipos = await clienteAxios.get(`/audiencia-tipo?sort=descripcion:asc`);

            const audienciaTipos = responseAudienciaTipos.data.content;

            setAudienciaTipos(audienciaTipos);

            const selectedTipos = audience?.audienciaTipoList?.map(at => {
                const tipo = audienciaTipos.find(
                    ta => ta.descripcion === at.descripcion
                );

                return {
                    id: tipo.id,
                    value: tipo.id,
                    label: tipo.descripcion
                };
            }) || [];

            setSelectedAudienciaTipos(selectedTipos);

            //Observaciones
            const responseObservaciones = await clienteAxios.get(`/audiencia/observacion-solicitante/${audience.id}`);
            setObservaciones(responseObservaciones?.data);

        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: MSG_ERROR_SERVER
            };
            //Verifico si hay error
            if(response)
            {   data = response.data;
            }
            //Mensaje de error
            ErrorMessage(data.message);
        }
    }

    //Esquema de validación
    const validationSchema = yup.object({
        tiposDeAudiencia: yup.array().required()
    });

    //Renderizo
    return (
        <Modal
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleClose } 
            onShow = { handleOnShow } 
            show = { show } 
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Editar Tipos de Audiencia <small>(Audiencia #{ audience?.id })</small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                initialValues = {{ ...initialData }}
                onSubmit = { values => handleSave(values) }
                validationSchema = { validationSchema }
            >
                {({
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors
                }) => (
                    <form autoComplete="off" noValidate onSubmit={handleSubmit}>
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <div className="alert alert-info">
                                        Seleccione los tipos de audiencia que desea asignar.
                                    </div>
                                </div>
                                <Form.Group className="col-md-12">
                                    <Select
                                        className = { !!errors.tiposDeAudiencia ? `is-invalid` : '' }
                                        id = "tiposDeAudiencia"
                                        isMulti
                                        name = "tiposDeAudiencia"
                                        noOptionsMessage = { ()=>("No se encontraron datos") }
                                        onChange = { (options, _e)=>handleChangeTipos(options, setFieldValue) }
                                        options = { AudienciaTipos?.map(ta =>(
                                                {   value: ta.id,
                                                    label: `${ta.descripcion}`
                                                }
                                            ))
                                        }
                                        placeholder = "Seleccione Tipo(s) de Audiencia"
                                        ref = { refTiposDeAudiencia }
                                        required = { true }
                                        value = { selectedAudienciaTipos }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.tiposDeAudiencia }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="observaciones">Observaciones</label>
                                    <Form.Control
                                        as = "textarea" 
                                        className = "form-control" 
                                        id = "observaciones"
                                        isInvalid = { !!errors.observaciones }
                                        name = "observaciones" 
                                        onChange = { handleChangeObservaciones }
                                        rows = { 4 }
                                        value = { observaciones }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.observaciones }
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button type="submit" variant="success">
                                <ICON_SAVE /> <strong>DUPLICAR</strong>
                            </Button>
                            <Button onClick={handleClose} variant="secondary">
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default CloneModal;